// Liste complète des 58 wilayas d'Algérie
export const WILAYAS = [
  { code: '01', name: 'ADRAR' },
  { code: '02', name: 'CHLEF' },
  { code: '03', name: 'LAGHOUAT' },
  { code: '04', name: 'OUM EL BOUAGHI' },
  { code: '05', name: 'BATNA' },
  { code: '06', name: 'BÉJAÏA' },
  { code: '07', name: 'BISKRA' },
  { code: '08', name: 'BÉCHAR' },
  { code: '09', name: 'BLIDA' },
  { code: '10', name: 'BOUIRA' },
  { code: '11', name: 'TAMANRASSET' },
  { code: '12', name: 'TÉBESSA' },
  { code: '13', name: 'TLEMCEN' },
  { code: '14', name: 'TIARET' },
  { code: '15', name: 'TIZI OUZOU' },
  { code: '16', name: 'ALGER' },
  { code: '17', name: 'DJELFA' },
  { code: '18', name: 'JIJEL' },
  { code: '19', name: 'SÉTIF' },
  { code: '20', name: 'SAÏDA' },
  { code: '21', name: 'SKIKDA' },
  { code: '22', name: 'SIDI BEL ABBÈS' },
  { code: '23', name: 'ANNABA' },
  { code: '24', name: 'GUELMA' },
  { code: '25', name: 'CONSTANTINE' },
  { code: '26', name: 'MÉDÉA' },
  { code: '27', name: 'MOSTAGANEM' },
  { code: '28', name: 'M\'SILA' },
  { code: '29', name: 'MASCARA' },
  { code: '30', name: 'OUARGLA' },
  { code: '31', name: 'ORAN' },
  { code: '32', name: 'EL BAYADH' },
  { code: '33', name: 'ILLIZI' },
  { code: '34', name: 'BORDJ BOU ARRERIDJ' },
  { code: '35', name: 'BOUMERDÈS' },
  { code: '36', name: 'EL TARF' },
  { code: '37', name: 'TINDOUF' },
  { code: '38', name: 'TISSEMSILT' },
  { code: '39', name: 'EL OUED' },
  { code: '40', name: 'KHENCHELA' },
  { code: '41', name: 'SOUK AHRAS' },
  { code: '42', name: 'TIPAZA' },
  { code: '43', name: 'MILA' },
  { code: '44', name: 'AÏN DEFLA' },
  { code: '45', name: 'NAÂMA' },
  { code: '46', name: 'AÏN TÉMOUCHENT' },
  { code: '47', name: 'GHARDAÏA' },
  { code: '48', name: 'RELIZANE' },
  { code: '49', name: 'TIMIMOUN' },
  { code: '50', name: 'BORDJ BADJI MOKHTAR' },
  { code: '51', name: 'OULED DJELLAL' },
  { code: '52', name: 'BÉNI ABBÈS' },
  { code: '53', name: 'IN SALAH' },
  { code: '54', name: 'IN GUEZZAM' },
  { code: '55', name: 'TOUGGOURT' },
  { code: '56', name: 'DJANET' },
  { code: '57', name: 'EL M\'GHAIR' },
  { code: '58', name: 'EL MENIAA' },
] as const;

/**
 * Normalise une chaîne en supprimant les accents et en la convertissant en majuscules
 */
export const normalizeString = (str: string): string => {
  return str
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // Supprime les accents
};

/**
 * Recherche les wilayas correspondant à un terme de recherche
 */
export const searchWilayas = (searchTerm: string): typeof WILAYAS => {
  console.log('🔍 searchWilayas appelé avec:', searchTerm);
  if (!searchTerm.trim()) return [];

  const normalizedSearch = normalizeString(searchTerm.trim());
  console.log('🔍 Terme normalisé:', normalizedSearch);

  const results = WILAYAS.filter(wilaya => {
    const normalizedCode = normalizeString(wilaya.code);
    const normalizedName = normalizeString(wilaya.name);
    
    const matches = (
      normalizedCode.includes(normalizedSearch) ||
      normalizedName.includes(normalizedSearch)
    );
    
    if (matches) {
      console.log('✅ Match trouvé:', wilaya.code, wilaya.name);
    }
    
    return matches;
  });
  
  console.log('📊 Nombre de résultats:', results.length);
  return results;
};

/**
 * Formate l'affichage d'une wilaya
 */
export const formatWilaya = (wilaya: typeof WILAYAS[number]): string => {
  return `${wilaya.code} - ${wilaya.name}`;
};